import { render, staticRenderFns } from "./RemovePaper.vue?vue&type=template&id=c705ada6&scoped=true&"
import script from "./RemovePaper.vue?vue&type=script&lang=js&"
export * from "./RemovePaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c705ada6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c705ada6')) {
      api.createRecord('c705ada6', component.options)
    } else {
      api.reload('c705ada6', component.options)
    }
    module.hot.accept("./RemovePaper.vue?vue&type=template&id=c705ada6&scoped=true&", function () {
      api.rerender('c705ada6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/components/RemovePaper.vue"
export default component.exports